<template>
  <v-container class="pt-1">
    <div class="flex-center">
      <span v-if="range[0] != range[1]"
        >Min: {{ range[0] }} - Max: {{ range[1] }}
      </span>
      <span v-if="range[0] === range[1]">Value: {{ range[0] }}</span>
    </div>
    <v-range-slider
      :disabled="disabled"
      v-model="range"
      :max="max"
      :min="min"
      hide-details
      class="align-center incidents_slider"
    ></v-range-slider>
    <div class="flex-between">
      <span>0:Low</span>
      <span>3:Medium</span>
      <span>6:High</span>
      <span>10:Emergency</span>
    </div>
  </v-container>
</template>

<script>
import lodashDebounce from "lodash/debounce";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "IncidentsSeveritySlider",
  props: {
    selected: {
      type: Array,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      range: [0, 10],
      max: 10,
      min: 0,
    };
  },
  mounted() {
    this.handleRangeChange();
  },
  methods: {
    handleRangeChange() {
      if (this.selected) {
        this.range = this.selected;
      }
    },
    emitRangeDebounced: lodashDebounce(async function () {
      this.$emit(EMITTED_ACTIONS.CHANGE, this.range);
    }, 500),
  },
  watch: {
    selected: {
      handler() {
        this.range = this.selected;
      },
    },
    range: {
      handler() {
        this.emitRangeDebounced();
      },
    },
  },
};
</script>

<style scoped>
.incidents_slider >>> .v-slider__tick-label {
  font-size: 12px !important;
}
.flex-center {
  display: flex;
  justify-content: center;
}
.flex-between {
  display: flex;
  justify-content: space-between;
  font-size: 9pt;
}
</style>
